import { render, staticRenderFns } from "./BotaoSaldoArmazem.vue?vue&type=template&id=b50e1c28&lang=pug"
import script from "./BotaoSaldoArmazem.vue?vue&type=script&lang=js"
export * from "./BotaoSaldoArmazem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports